import { Icon } from "@repo/components/src/ui/icon";
import { Image } from "@repo/components/src/ui/image";
import { ExternalPathString, Link } from "expo-router";
import { Play } from "lucide-react-native";
import { MediaViewerProps } from "../types";

const ThumbnailLink = (props: MediaViewerProps) => {
  const thumbnailUrl = props.thumbnail?.url;
  const post = props.post;
  const postContent = props.postContent;
  const isVideo = postContent.postContentType.platformCode === "VIDEO";

  return (
    <>
      <Image
        source={{ uri: thumbnailUrl }}
        size="full"
        contentFit="contain"
        alt="Thumbnail"
      />
      <Link
        href={post.link as ExternalPathString}
        target="_blank"
        className="absolute inset-0 z-20 flex rounded-xl h-full justify-center items-center bg-black/0 hover:bg-black/40 transition-all duration-300"
      >
        <Icon
          as={Play}
          className={`${isVideo ? "opacity-100" : "opacity-0"} fill-white stroke-none`}
          size={"3xl"}
        />
      </Link>
    </>
  );
};

export default ThumbnailLink;
